// extracted by extract-css-chunks-webpack-plugin
module.exports = {"controlContainer":"bulk-change-panel__controlContainer--3ozRr","count":"bulk-change-panel__count--3PIWz"};